<div class="comment-wrapper" id="comment-wrapper" [ngClass]="{ 'privat-tab': isVisibilitySelected('PRIVATE') }">
  <div class="side-edit-mode-btn" *ngIf="isCloseable">
    <button type="button" class="btn btn-icon-only side-edit-mode-btn-close" (click)="close()" id="close-comment-panel" [rlAria] [tooltip]="'general.close' | translate" [tooltipPlacement]="right" [rlTabIndex]>
      <span>&#x2715;</span>
      <span class="sr-only">{{ 'general.close' | translate }}</span>
    </button>
  </div>
  <div class="comment-wrapper-top-inner">
    <div class="justify-content flex-wrap">
      <div class="flex-basis" *ngIf="allowRefresh && isVisibilitySelected('PUBLIC')">
        <div
          type="button"
          id="refresh-comments"
          class="btn btn-clear"
          [ngClass]="{ disabled: busy }"
          (click)="refresh()"
          (keydown.enter)="refresh()"
          (keydown.space)="refresh()"
          [rlAria]
          accessibleTooltip
          [tooltip]="'embeddedview.annotations.refresh' | translate"
          triggers="manual"
          placement="bottom"
          tabindex="0">
          <i class="fa fa-refresh"></i>
          <span class="sr-only">{{ 'embeddedview.annotations.refresh' | translate }}</span>
        </div>
      </div>
      <div class="flex-basis">
        <rl-search *ngIf="comments.length > 0" (onSearch)="search((searchTerm = $event))" [(showSearch)]="hideDeleteAll" (getPrevResult)="markResult()" (getNextResult)="markResult()"></rl-search>
      </div>
    </div>
    <!-- <div *ngIf="!hideDeleteAll"> -->
    <!-- <button type="button" class="btn btn-link" (click)="deleteAll()" id="delete-all-comment" *ngIf="comments.length > 0">
                <i class="fa fa-trash no-margin" attr.aria-hidden="true"></i>
            </button> -->
    <!-- </div> -->
  </div>
  <div class="comment-wrapper-inner" [ngClass]="{ 'search-activated': hideDeleteAll }">
    <div class="add-comment-msg" role="alert" *ngIf="displayPrivatePublicTabs && comments.length === 0">
      <div class="add-comment-msg-icon">
        <span *ngIf="isVisibilitySelected('PRIVATE')">
          <i class="fa fa-comment"></i>
        </span>
        <span *ngIf="isVisibilitySelected('PUBLIC')">
          <i class="fa fa-comments"></i>
        </span>
      </div>
      <p class="add-comment-msg-title">{{ 'embeddedview.annotations.nocomments.' + visibilityTab | translate }}</p>
    </div>
    <div *ngIf="messages.length" class="alert alert-info" role="alert">
      <div *ngFor="let m of messages" class="justify-content">
        <div class="flex-start">
          <p>{{ m | translate }}</p>
        </div>
      </div>
    </div>
    <div class="comment-wrapper-inner-holder">
      <rl-please-wait *ngIf="busy"></rl-please-wait>
      <ul [rlToggleGroup] *ngIf="!busy && comments.length" class="media-list">
        <li
          [ngClass]="{ 'annotator-hover': hoverCommentId == c.attachedId }"
          *ngFor="let c of comments; let i = index"
          id="{{ 'comment-' + i }}"
          (mouseenter)="toggleHoverComment(comments[i].attachedId)"
          (mouseleave)="toggleHoverComment(comments[i].attachedId)"
          (click)="toggleSelectComment(comments[i].attachedId)"
          attr.annId="{{ comments[i].attachedId }}">
          <rl-comment
            [rlToggle]
            [comment]="c"
            [searchResults]="searchResults | startsWith : 'objectIndex' : i"
            [searchResultsIndex]="i"
            [hideMenu]="hideCommentsMenu"
            [visibilityAllowed]="config.commentsConfig.visibility"
            [privateIndication]="config.commentsConfig.privateIndication"
            (onDelete)="deleteComment(c.orgIndex || i, $event)"
            (onDeleteCanceled)="cancelComment(c.attachedId)"
            (onSetAsPublic)="changeVisibility(c.orgIndex || i, 'PUBLIC')"
            (onSetAsPrivate)="changeVisibility(c.orgIndex || i, 'PRIVATE')"
            (onEditSaved)="save($event, c.orgIndex || i)"
            (onEditCanceled)="cancel(c.orgIndex || i)"
            (onEditClicked)="editComment(c.orgIndex || i)"
            (onReply)="createNewSubAnnotation(c, $event)"></rl-comment>
        </li>
      </ul>
    </div>
  </div>
  <div class="comment-wrapper-bottom" *ngIf="actionBtns.length">
    <ng-container>
      <div class="justify-content" *ngFor="let b of actionBtns">
        <div class="flex-end">
          <button type="button" class="btn btn-primary" [id]="b.label" (click)="b.action()" [rlAria]="b.label | translate">{{ b.label | translate }}</button>
        </div>
      </div>
    </ng-container>
  </div>
</div>
